// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nav":"nav_ZNkBL","tab":"tab_3SdCi","tab_active":"tab_active_2cXZN"};